/* AUTEUR PDP test system. Reveal, gallery, quantity, sticky bar. */
(function(){
  function boot(){
    var roots = document.querySelectorAll('.apdp');
    roots.forEach(function(r){ r.classList.add('is-ready'); });

    var targets = document.querySelectorAll('.apdp [data-rv]');
    var revealAll = function(){ targets.forEach(function(t){ t.classList.add('is-in'); }); };

    if(!('IntersectionObserver' in window)){
      revealAll();
    } else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){
            var d = parseInt(e.target.getAttribute('data-rv'),10) || 0;
            if(d > 8){ d = 8; }
            e.target.style.transitionDelay = (d * 70) + 'ms';
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
      targets.forEach(function(t){ io.observe(t); });
      setTimeout(revealAll, 1600);
    }

    document.querySelectorAll('[data-apdp-gallery]').forEach(function(root){
      var main = root.querySelector('[data-apdp-main] img');
      var thumbs = root.querySelectorAll('.apdp-gal__t[data-src]');
      thumbs.forEach(function(t){
        t.addEventListener('click', function(){
          if(main){ main.src = t.getAttribute('data-src'); }
          thumbs.forEach(function(x){
            x.classList.remove('is-on');
            x.setAttribute('aria-current','false');
          });
          t.classList.add('is-on');
          t.setAttribute('aria-current','true');
        });
      });
    });

    document.querySelectorAll('.apdp-qty').forEach(function(q){
      var input = q.querySelector('input');
      q.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click', function(){
          var n = parseInt(input.value || '1', 10) + parseInt(b.getAttribute('data-step'), 10);
          input.value = n < 1 ? 1 : n;
        });
      });
    });

    var bar = document.querySelector('[data-apdp-sticky]');
    var anchor = document.querySelector('[data-apdp-atc]');
    if(bar){
      var onScroll = function(){
        if(anchor){
          var r = anchor.getBoundingClientRect();
          if(r.bottom < 0){ bar.classList.add('is-on'); } else { bar.classList.remove('is-on'); }
          return;
        }
        if(window.scrollY > 820){ bar.classList.add('is-on'); } else { bar.classList.remove('is-on'); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
